import { Link, Navigate } from 'react-router-dom';
import LinkListWithHeading from '../Shared/LinkListWithHeading';
import PageIntroduction from '../Shared/PageIntroduction';
import useFetch, { Status } from '../../../hooks/fetch.hook';
import type { UserApiModel } from '../models/user.api-model';

function Administrator() {
  // === STATE ===
  const [{ status: getMunicipalitiesStatus, httpResponseStatusCode }] = useFetch<UserApiModel[]>('/api/paegnaben/admin/municipalities');

  // === RENDER ===
  if (getMunicipalitiesStatus === Status.failed && httpResponseStatusCode === 401) {
    return <Navigate to="/session-utgangen" />;
  }

  if (getMunicipalitiesStatus === Status.failed && httpResponseStatusCode === 403) {
    return <Navigate to="/atkomst-saknas" />;
  }

  return (
    <div>
      <PageIntroduction heading="Administration" />
      <LinkListWithHeading
        heading="Genvägar"
        listItems={[
          <Link key="anvandare" to="/anvandare" className="text-decoration-none">
            Användare
          </Link>,
          <Link key="tavlingar" to="/tavlingar" className="text-decoration-none">
            Tävlingar
          </Link>,
          <Link key="kommuner" to="/kommuner" className="text-decoration-none">
            Kommuner
          </Link>,
          <Link key="statistik" to="/statistik" className="text-decoration-none">
            Statistik
          </Link>,
          <form key={'logga-ut'} action="/konto/logga-ut" method="post">
            <button type="submit" className="btn--as-link text-decoration-none w-100 text-start">
              <span className="">{'Logga ut'}</span>
            </button>
          </form>,
        ]}
      />
    </div>
  );
}

export default Administrator;
